import type { components as definitions, paths } from "@securityjourney/svc-pla/dist/gen/pla.d.ts";

import { OpenApiFetchWrapper } from "./openApiFetchWrapper";

export type PersonalizedLessonAssignment =
  definitions["schemas"]["securityjourney.proto.pla.PersonalizedLessonAssignment"];
export type TenantPLAResponse =
  definitions["schemas"]["securityjourney.proto.pla.TenantPLAResponse"];
export type UpdatePLAResponse =
  definitions["schemas"]["securityjourney.proto.pla.UpdatePLAResponse"];
export type LessonDetails = definitions["schemas"]["securityjourney.proto.pla.LessonDetails"];
export type PLASource = definitions["schemas"]["securityjourney.proto.pla.PLASource"];
export type LearnerDetails = definitions["schemas"]["securityjourney.proto.pla.LearnerDetails"];
type UpdatePLARequestBody = NonNullable<
  paths["/svc/pla/{tenant}/{uuid}"]["patch"]["requestBody"]
>["content"]["application/json"];

export class PlaClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super();
  }

  async getTenantPLAs(tenant: string, directoryUuids?: string[]) {
    return await this.get("/svc/pla/tenant/{tenant}", {
      params: { path: { tenant }, query: { directoryUuids } },
    });
  }

  async updatePLA(tenant: string, uuid: string, body: UpdatePLARequestBody) {
    return await this.patch("/svc/pla/{tenant}/{uuid}", {
      params: { path: { tenant, uuid } },
      body,
    });
  }
}
